var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidenav-logo"},[(!_vm.customLogo.file_url)?_c('base-image',{attrs:{"src":_vm.url}}):_c('base-image',{attrs:{"src":_vm.customLogo.file_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }